<template>
  <div class="activity-wrap">
    <div id="container" class="container">
      <div class="item1" style="height:690px;">
        <!-- 第一个按钮 -->
        <div class="btn" style="width:350px;bottom: 230px;" @click="goFree365()"></div>
      </div>
      <div class="item" style="width:900px;margin:auto;padding: 0 50px 13px 50px;box-sizing: border-box;border:1px solid #564b2c;border-top: none;border-radius: 0 0 10px 10px;"><img src="../../assets/images/activity/activity20240801/lmsj.gif" alt=""></div>
      <div class="item2" style="margin:auto;padding:10px;height:100px;width:508px">
        <!-- 第二个按钮 -->
        <div class="btn" style="width:510px;bottom: 20px;" @click="goFree365()"></div>
      </div>
      <div class="item3" style="height: 738px">
        <!-- 第三个按钮 -->
        <div class="btn" style="width:310px;" @click="goFree365()"></div>
      </div>
      <div class="item4" style="height: 760px">
        <!-- 第四个按钮 -->
        <div class="btn" style="width:550px;" @click="goFree365()"></div>
      </div>
      <div class="item5" style="height: 672px">
        <!-- 第五个按钮 -->
        <div class="btn" style="width:550px;" @click="goFree365()"></div>
      </div>
      <div class="item6" style="height: 458px"></div>
    </div>

    <div class="popup" :class="{success: popupData.type === 'success', error: popupData.type === 'error'}" v-if="popupOn">
      <div class="title">{{ popupData.title }}</div>
      <div class="desc">{{ popupData.content }}</div>
      <div class="btn" @click.stop="popupOn=false">{{ popupData.buttonText }}</div>
    </div>
  </div>
</template>
<script type="text/javascript" src="https://mnews.dzh.com.cn/wap/style/other/js/stat-tj.js"></script>
<script type="text/javascript" src="https://mnews.dzh.com.cn/wap/style/common/js/zepto.min.js"></script>
<script type="text/javascript" src="https://mnews.dzh.com.cn/wap/style/common/js/rem_750_100_min.js"></script>
<script src="js/vue.min.js"></script>
<link type="text/css" media="all" rel="stylesheet" href="https://mnews.dzh.com.cn/wap/style/common/css/base_min.css" />

<script>
export default {
  components: {
  },
  data() {
    return {
      popupOn:false,
      popupData: {
          type: 'success', // 'success' or 'error'
          title: '您已领取过该福利',
          content: '活动名额有限，每人限领1次',
          buttonText: '我知道了'
        }
    }
  },
  watch: {
  },
  created() {},
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    goFree365(){
      this.$post("/user/free365Power")
        .then(response => {
          if (response.code === 0) {
            this.popupOn = true,
            this.popupData.type = 'success',
            this.popupData.title= '恭喜 领取成功',
            this.popupData.content= '已为您的账号成功开通大智慧「365」收费版30天使用特权，退出软件重登后即可使用。'
          }else if (response.code === 502){
            this.popupOn = true;
            this.popupData.type = 'success',
            this.popupData.title= '您已领取过该福利',
            this.popupData.content= '活动名额有限，每人限领1次'
          }else if (response.code == 501) {
            this.popupOn = true;
            this.popupData.type = 'error',
            this.popupData.title= '抱歉 领取失败',
            this.popupData.content= '您暂不符合活动要求哦，请下次再来吧'
          }else if (response.code == 549) {
            this.popupOn = true;
            this.popupData.type = 'error',
            this.popupData.title= '很遗憾',
            this.popupData.content= '活动名额已满，请下次再来吧'
          }else {
            alert(response.msg)
          }
      })
        .catch(err => {
          alert("网络异常，请稍后重试");
        });
    }
  }
};
</script>

<style type="text/css" scoped>
[v-cloak]{
  display: none;
}
.activity-wrap {
  background-color: #131313;
}
.item1 {background-image: url('../../assets/images/activity/activity20240801/pic_01.jpg');position: relative;min-width: 900px;background-position: center center;background-repeat: no-repeat;}
.item {position: relative;min-width: 900px;background-position: center center;background-repeat: no-repeat;}
.item2 {background-image: url('../../assets/images/activity/activity20240801/pic_02.jpg');position: relative;min-width: 900px;background-position: center center;background-repeat: no-repeat;}
.item3 {background-image: url('../../assets/images/activity/activity20240801/pic_03.jpg');position: relative;min-width: 900px;background-position: center center;background-repeat: no-repeat;}
.item4 {background-image: url('../../assets/images/activity/activity20240801/pic_04.jpg');position: relative;min-width: 900px;background-position: center center;background-repeat: no-repeat;}
.item5 {background-image: url('../../assets/images/activity/activity20240801/pic_05.jpg');position: relative;min-width: 900px;background-position: center center;background-repeat: no-repeat;}
.item6 {background-image: url('../../assets/images/activity/activity20240801/pic_06.jpg');position: relative;min-width: 900px;background-position: center center;background-repeat: no-repeat;}
.activity-wrap .container .btn{position: absolute;bottom: 12px;left: 50%;height: 80px;-webkit-transform: translateX(-50%);transform: translateX(-50%);cursor: pointer;}img{display:block;width:100%}
.popup{position: fixed;top: 10%;left: 50%;width:435px;height:480px;text-align: center;-webkit-transform: translateX(-50%);transform: translateX(-50%);}
.popup.success{background-image: url('../../assets/images/activity/activity20240801/success.png');}
.popup.error{background-image: url('../../assets/images/activity/activity20240801/error.png');}
.popup .title{font-size: 38px;color: #262626;margin-top: 203px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;padding: 0 10px}
.popup .desc{font-size: 20px;color: #333;margin-top: 40px;line-height: 1.6;max-height:65px;overflow: hidden;padding: 0 10px;}
.popup .btn{width:278px;height:58px;line-height:58px;color:#fff;font-weight: bold;background: -webkit-linear-gradient(to right, #fd8b45 , #fc362d);background: linear-gradient(to right, #fd8b45 , #fc362d);font-size: 26px;margin: 40px auto 0;border-radius: 100px;cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/pages/activity/activity20240801.vue